/*----------------------------------
- TOOLS MEGA MENU
----------------------------------*/

import { LANDING_MENU_PANEL_COPY } from '@/client/catalogs/landing/menuPanels';
import { LANDING_TOOLS_MENU_ITEMS } from '@/client/catalogs/landing/toolsMenu';
import MegaMenuPanel from './MegaMenuPanel';
import MenuPanelHeader from './MenuPanelHeader';
import MenuRow from './MenuRow';
import type { MenuNavigateHandler } from './navClick';

/*----------------------------------
- TYPES
----------------------------------*/

type ToolsMegaMenuProps = {
    id: string;
    isOpen: boolean;
    onNavigate: MenuNavigateHandler;
};

/*----------------------------------
- CONSTANTS
----------------------------------*/

const COPY = LANDING_MENU_PANEL_COPY.tools;

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * The standalone tools: the ones a visitor can open without a workflow around them.
 * A list, because that is what it is: one `<li>` per row, so a crawler and a screen
 * reader both get the count before the first one. Data and the API documentation left
 * this menu on 2026-09-17: they describe the database rather than act on a name, and
 * they keep their footer links.
 */
export default function ToolsMegaMenu({ id, isOpen, onNavigate }: ToolsMegaMenuProps) {
    return (
        <MegaMenuPanel id={id} testId="tools-mega-menu" isOpen={isOpen} width="narrow">
            <MenuPanelHeader title={COPY.title} lead={COPY.lead} />

            <ul class="mt-[22px] grid grid-cols-2 gap-x-8" data-testid="tools-menu-rows">
                {LANDING_TOOLS_MENU_ITEMS.map((item) => (
                    <li key={item.id}>
                        <MenuRow
                            href={item.href}
                            status={item.status}
                            label={item.label}
                            description={item.description}
                            iconName={item.iconName}
                            trailing={item.cta ? `${item.cta} →` : undefined}
                            trailingTone="action"
                            tile="ink"
                            onClick={() => item.href && onNavigate(item.id, item.href)}
                        />
                    </li>
                ))}
            </ul>
        </MegaMenuPanel>
    );
}
